import type { QueryClient } from '@tanstack/react-query';
import { queryKeys } from './queries';

export function invalidateTickets(queryClient: QueryClient, incidentId: string): Promise<void> {
  return queryClient.invalidateQueries({
    queryKey: queryKeys.tickets(incidentId),
  });
}

export function invalidateTicketDetail(queryClient: QueryClient, ticketId: string): Promise<void> {
  return queryClient.invalidateQueries({
    queryKey: queryKeys.ticket(ticketId),
  });
}

export function invalidateAllCatalog(queryClient: QueryClient): Promise<void> {
  return queryClient.invalidateQueries({
    predicate: (query) => {
      const key = query.queryKey[0];
      return key === 'catalog' || key === 'componentCatalog';
    },
  });
}
